import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseProvider } from '../BaseProvider';
import { CommentsRequestModel, CommentsResponseModel } from './../../_models/index';
import { GlobalService } from '../../_global/global.service';

@Injectable()
export class CommentsService extends BaseProvider {

    getCommentsUrl = 'orders/##orderId##/comments';
    postCommentsUrl = 'orders/##orderId##/comments';

    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
    }

    getComments(orderId: string) {
        let url: string = this.getCommentsUrl.replace('##orderId##', orderId);
        return this.makeGetCall(url);
    }

    postComments(orderId: string, objComments: CommentsRequestModel) {
        let url: string = this.getCommentsUrl.replace('##orderId##', orderId);
        return this.makePostCall(url, objComments);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/comments/comments.service.ts